import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";
import IShift from "@/models/Shifts/IShift";

export default class AnonOfferedReplyViewModel implements IShift {
    bookingRoleWorkerShiftId = '';
    startAt: Date;
    endAt: Date;
	apply = false;
	declinedReason: ShiftDeclinedReason;
}